// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paylixecommerce-modal.update-theme-modal {
  width: 50vw;
  display: flex;
  flex-direction: column;
}

.update-theme-modal .options-container {
  padding: 1.5rem 1.5rem 0;
  border-top: 1px solid var(--black2);
  overflow: hidden;
}
.update-theme-modal .options-wrapper {
  border-radius: 0.5rem;
  border: 1px solid var(--black2);
}
.update-theme-modal .options-header {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  color: var(--black9);
}
.update-theme-modal .options-title {
  font-weight: 600;
  line-height: 20px;
}
.update-theme-modal .options-content {
  display: none;
  height: 0;
  transition: height 0.2s ease-out;
}
.update-theme-modal .options-content.open {
  display: block;
  height: fit-content;
  padding: 0 1.25rem 1.25rem;
}
.update-theme-modal .options-content .help-text {
  line-height: 20px;
  color: var(--black5);
}
.update-theme-body {
  padding: 0;
  overflow: auto;
  max-height: calc(100% - 150px);
  height: 100%;
  flex: 1;
}
.update-theme-footer.paylixecommerce-modal-footer {
  border-top: none;
}
.update-theme-list {
  font-size: 14px;
}
.update-theme-list-body {
  padding: 1.25rem 1.5rem;
}
.update-theme-list-subheader {
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  font-weight: 600;
  color: var(--black9);
  padding: 0.5rem 1.5rem;
  border-bottom: 1px solid var(--black1);
  cursor: pointer;
  background: var(--black0);
}
.update-theme-list-subheader:last-of-type {
  border-bottom: none;
}
.update-theme-list-subheader svg {
  cursor: pointer;
}
.update-theme-list-item svg {
  font-size: 16px;
}
.update-theme-list-item svg path {
  color: var(--black9);
}
.update-theme-list-item p {
  font-size: 0.85rem;
  font-weight: 400;
  color: var(--black9);
}
.update-theme-list-item h1 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--black9);
  padding-top: 0;
}
.update-theme-list-item h2 {
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--black9);
  padding-top: 1rem;
}
.update-theme-list-item h3 {
  font-size: 1.1rem;
  font-weight: 500;
  color: var(--black9);
  padding-top: 1rem;
}
.update-theme-list-item ul li {
  color: var(--black9);
}
.update-theme-list-item h1 + p img {
  width: auto;
  object-fit: fill;
  border-radius: 0.25rem;
  border: 1px solid var(--black1);
}
.update-theme-list-item img {
  width: 100%;
  object-fit: fill;
  border-radius: 0.5rem;
}
.update-theme-controls {
  display: flex;
  justify-content: flex-end;
  padding: 0 1.5rem 1.5rem 1.5rem;
  width: 100%;
}
.update-theme-controls button {
  margin-left: 1rem;
}
.update-theme-controls button svg {
  margin-right: 0.5rem;
}

.status-body {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 14px;
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.status-body .status-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: var(--green1);
  color: var(--green6);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}
.status-body .status-title {
  font-weight: 600;
  font-size: 16px;
  padding: 0.5rem 0;
}
.status-body-controls button {
  width: 100%;
  margin-left: 0;
}

.conflicts-body {
  display: flex;
  flex: 1;
  padding: 0;
  max-height: 100%;
  background-color: var(--white);
  color: var(--black5);
}
.conflicts-list {
  width: 320px;
  border-right: 1px solid var(--black2);
  overflow-y: auto;
  overflow-x: hidden;
}
.conflicts-list-item {
  border-bottom: 1px solid var(--black2);
  padding: 0.5rem 0 0.5rem 1.875rem;
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
}
.conflicts-list-item:hover {
  cursor: pointer;
}
.conflicts-list-item svg {
  margin-right: 0.5rem;
}
.conflicts-list-item.active {
  background-color: var(--black0);
}
.conflicts-content {
  flex: 1;
  padding-top: 1.25rem;
}
.conflicts-header {
  display: flex;
  align-items: center;
  padding-left: 1.875rem;
  color: var(--black9);
}
.conflicts-header svg {
  margin-right: 0.5rem;
}
.conflicts-footer {
  padding: 0.875rem 1.875rem;
}
.conflicts-footer button.resolve svg {
  margin-right: 0.5rem;
}

.rightLineDecoration {
  background-color: var(--purple2);
  opacity: 0.5;
}
.rightLineDecoration.dark {
  background-color: var(--purple9);
}

.leftLineDecoration {
  background-color: var(--red1);
  opacity: 0.5;
}
.leftLineDecoration.dark {
  background-color: var(--red8);
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/customization/themes/cards/update/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAKM;EACE,wBAAA;EACA,mCAAA;EACA,gBAAA;AAFR;AAIM;EACE,qBAAA;EACA,+BAAA;AAFR;AAIM;EACE,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,oBAAA;AAFR;AAIM;EACE,gBAAA;EACA,iBAAA;AAFR;AAKM;EACE,aAAA;EACA,SAAA;EACA,gCAAA;AAHR;AAKQ;EACE,cAAA;EACA,mBAAA;EACA,0BAAA;AAHV;AAMQ;EACE,iBAAA;EACA,oBAAA;AAJV;AAWE;EACE,UAAA;EACA,cAAA;EACA,8BAAA;EACA,YAAA;EACA,OAAA;AATJ;AAYE;EACE,gBAAA;AAVJ;AAaE;EACE,eAAA;AAXJ;AAaI;EACE,uBAAA;AAXN;AAcI;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,sCAAA;EACA,eAAA;EACA,yBAAA;AAZN;AAcM;EACE,mBAAA;AAZR;AAeM;EACE,eAAA;AAbR;AAiBM;EACE,eAAA;AAfR;AAgBQ;EACE,oBAAA;AAdV;AAkBM;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;AAhBR;AAmBM;EACE,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AAjBR;AAmBM;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AAjBR;AAmBM;EACE,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AAjBR;AAoBM;EACE,oBAAA;AAlBR;AAsBQ;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,+BAAA;AApBV;AAwBM;EACE,WAAA;EACA,gBAAA;EACA,qBAAA;AAtBR;AA2BE;EACE,aAAA;EACA,yBAAA;EACA,+BAAA;EACA,WAAA;AAzBJ;AA2BI;EACE,iBAAA;AAzBN;AA2BM;EACE,oBAAA;AAzBR;;AA8BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AA3BF;AA6BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AA3BJ;AA8BE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AA5BJ;AAgCI;EACE,WAAA;EACA,cAAA;AA9BN;;AAoCE;EACE,aAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;EAEA,8BAAA;EACA,oBAAA;AAlCJ;AAoCE;EACE,YAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;AAlCJ;AAoCI;EACE,sCAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAlCN;AAoCM;EACE,eAAA;AAlCR;AAqCM;EACE,oBAAA;AAnCR;AAsCM;EACE,+BAAA;AApCR;AAwCE;EACE,OAAA;EACA,oBAAA;AAtCJ;AAwCE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;AAtCJ;AAwCI;EACE,oBAAA;AAtCN;AAyCE;EACE,0BAAA;AAvCJ;AAyCM;EACE,oBAAA;AAvCR;;AA6CA;EACE,gCAAA;EAIA,YAAA;AA7CF;AA0CE;EACE,gCAAA;AAxCJ;;AA6CA;EACE,6BAAA;EAIA,YAAA;AA7CF;AA0CE;EACE,6BAAA;AAxCJ","sourcesContent":[".paylixecommerce-modal.update-theme-modal {\n  width: 50vw;\n  display: flex;\n  flex-direction: column;\n}\n\n.update-theme {\n  &-modal {\n    .options {\n      &-container {\n        padding: 1.5rem 1.5rem 0;\n        border-top: 1px solid var(--black2);\n        overflow: hidden;\n      }\n      &-wrapper {\n        border-radius: .5rem;\n        border: 1px solid var(--black2);\n      }\n      &-header {\n        padding: 1rem 1.5rem;\n        display: flex;\n        justify-content: space-between;\n        cursor: pointer;\n        color: var(--black9);\n      }\n      &-title {\n        font-weight: 600;\n        line-height: 20px;\n      }\n\n      &-content {\n        display: none;\n        height: 0;\n        transition: height .2s ease-out;\n\n        &.open {\n          display: block;\n          height: fit-content;\n          padding: 0 1.25rem 1.25rem;\n        }\n\n        .help-text {\n          line-height: 20px;\n          color: var(--black5);\n        }\n\n      }\n    }\n  }\n\n  &-body {\n    padding: 0;\n    overflow: auto;\n    max-height: calc(100% - 150px);\n    height: 100%;\n    flex: 1;\n  }\n\n  &-footer.paylixecommerce-modal-footer {\n    border-top: none;\n  }\n\n  &-list {\n    font-size: 14px;\n\n    &-body {\n      padding: 1.25rem 1.5rem;\n    }\n\n    &-subheader {\n      display: flex;\n      justify-content: space-between;\n      font-size: 1rem;\n      font-weight: 600;\n      color: var(--black9);\n      padding: .5rem 1.5rem;\n      border-bottom: 1px solid var(--black1);\n      cursor: pointer;\n      background: var(--black0);\n\n      &:last-of-type {\n        border-bottom: none;\n      }\n\n      svg {\n        cursor: pointer;\n      }\n    }\n    &-item {\n      svg {\n        font-size: 16px;\n        path {\n          color: var(--black9);\n        }\n      }\n\n      p {\n        font-size: .85rem;\n        font-weight: 400;\n        color: var(--black9);\n      }\n\n      h1 {\n        font-size: 1.5rem;\n        font-weight: 600;\n        color: var(--black9);\n        padding-top: 0;\n      }\n      h2 {\n        font-size: 1.25rem;\n        font-weight: 500;\n        color: var(--black9);\n        padding-top: 1rem;\n      }\n      h3 {\n        font-size: 1.1rem;\n        font-weight: 500;\n        color: var(--black9);\n        padding-top: 1rem;\n      }\n\n      ul li {\n        color: var(--black9);\n      }\n\n      h1 + p {\n        img {\n          width: auto;\n          object-fit: fill;\n          border-radius: 0.25rem;\n          border: 1px solid var(--black1);\n        }\n      }\n\n      img {\n        width: 100%;\n        object-fit: fill;\n        border-radius: 0.5rem;\n      }\n    }\n  }\n\n  &-controls {\n    display: flex;\n    justify-content: flex-end;\n    padding: 0 1.5rem 1.5rem 1.5rem;\n    width: 100%;\n\n    button {\n      margin-left: 1rem;\n\n      svg {\n        margin-right: 0.5rem;\n      }\n    }\n  }\n}\n.status-body {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  font-size: 14px;\n  padding-top: 5rem;\n  padding-bottom: 5rem;\n\n  .status-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background-color: var(--green1);\n    color: var(--green6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 1rem;\n  }\n\n  .status-title {\n    font-weight: 600;\n    font-size: 16px;\n    padding: 0.5rem 0;\n  }\n\n  &-controls {\n    button {\n      width: 100%;\n      margin-left: 0;\n    }\n  }\n}\n\n.conflicts {\n  &-body {\n    display: flex;\n    flex: 1;\n    padding: 0;\n    max-height: 100%;\n\n    background-color: var(--white);\n    color: var(--black5);\n  }\n  &-list {\n    width: 320px;\n    border-right: 1px solid var(--black2);\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    &-item {\n      border-bottom: 1px solid var(--black2);\n      padding: 0.5rem 0 0.5rem 1.875rem;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 19px;\n\n      &:hover {\n        cursor: pointer;\n      }\n\n      svg {\n        margin-right: 0.5rem;\n      }\n\n      &.active {\n        background-color: var(--black0);\n      }\n    }\n  }\n  &-content {\n    flex: 1;\n    padding-top: 1.25rem;\n  }\n  &-header {\n    display: flex;\n    align-items: center;\n    padding-left: 1.875rem;\n    color: var(--black9);\n\n    svg {\n      margin-right: 0.5rem;\n    }\n  }\n  &-footer {\n    padding: 0.875rem 1.875rem;\n    button.resolve {\n      svg {\n        margin-right: 0.5rem;\n      }\n    }\n  }\n}\n\n.rightLineDecoration {\n  background-color: var(--purple2);\n  &.dark {\n    background-color: var(--purple9);\n  }\n  opacity: 0.5;\n}\n\n.leftLineDecoration {\n  background-color: var(--red1);\n  &.dark {\n    background-color: var(--red8);\n  }\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
